module.exports = __webpack_public_path__ + "static/media/repair_wheel.e162c44c.jpg";